import type { DataTableSkeletonProps } from '~/components/common/data-table/data-table.types';
import { Skeleton } from '~/components/ui/skeleton';
import { TableCell, TableRow } from '~/components/ui/table';

/**
 * Renders placeholder skeleton rows while the table data is loading.
 * Matches the column count of the live table so the layout does not shift.
 */
export function DataTableSkeleton({ columns, rows }: DataTableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <TableRow key={i}>
          {Array.from({ length: columns }, (__, j) => (
            <TableCell key={j}>
              <Skeleton className="h-5 w-24 rounded" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
